"use client";

import { sectionConfig as config } from "~/config/_pages/home/plans";
import PlanUI from "~/components/ui/_home/plan";
import type { BucketIcon } from "~/types/icon";

import enterpriseWebuiService from "~/assets/plans-banners/enterprise-openwebui-service.svg";
import ultraService from "~/assets/plans-banners/ultra-plan.svg";
import proBanner from "~/assets/plans-banners/openwebui-app-service.svg";
import type { PlanColor } from "~/components/ui/_home/plan/_types";

export default function PlansSection() {
  return (
    <>
      <PlanUI color={config.app_service.color as PlanColor} reversed>
        <PlanUI.Banner url={proBanner.src} alt={config.app_service.title} />
        <PlanUI.Body>
          <PlanUI.Heading
            pre={config.app_service.pre}
            name={config.app_service.title}
          >
            {config.app_service.caption}
          </PlanUI.Heading>
          <PlanUI.Grid>
            {config.app_service.features.map((item, index) => (
              <PlanUI.Item
                key={index}
                caption={item.caption}
                title={item.title}
                icon={item.icon as BucketIcon}
              />
            ))}
          </PlanUI.Grid>
          <PlanUI.Purchase
            label={config.app_service.start_button.label}
            paymentUrl={config.app_service.start_button.link}
          >
            {config.app_service.uni_line_price}
          </PlanUI.Purchase>
        </PlanUI.Body>
      </PlanUI>

      <PlanUI color={config.pro_service.color as PlanColor}>
        <PlanUI.Banner url={ultraService.src} alt={config.pro_service.title} />
        <PlanUI.Body>
          <PlanUI.Heading
            pre={config.pro_service.pre}
            name={config.pro_service.title}
          >
            {config.pro_service.caption}
          </PlanUI.Heading>
          <PlanUI.Grid>
            {config.pro_service.features.map((item, index) => (
              <PlanUI.Item
                key={index}
                caption={item.caption}
                title={item.title}
                icon={item.icon as BucketIcon}
              />
            ))}
          </PlanUI.Grid>
          <PlanUI.Purchase
            label={config.pro_service.start_button.label}
            paymentUrl={config.pro_service.start_button.link}
            utm_term={config.pro_service.start_button.term}
            useRef={config.pro_service.start_button.ref}
            queryParams={{
              sub: "sub-ultra",
            }}
          >
            {config.pro_service.uni_line_price}
          </PlanUI.Purchase>
        </PlanUI.Body>
      </PlanUI>

      <PlanUI color={config.org_service.color as PlanColor} reversed>
        <PlanUI.Banner
          url={enterpriseWebuiService.src}
          alt={config.org_service.title}
        />
        <PlanUI.Body>
          <PlanUI.Heading
            pre={config.org_service.pre}
            name={config.org_service.title}
          >
            {config.org_service.caption}
          </PlanUI.Heading>
          <PlanUI.Grid>
            {config.org_service.features.map((item, index) => (
              <PlanUI.Item
                key={index}
                caption={item.caption}
                title={item.title}
                icon={item.icon as BucketIcon}
              />
            ))}
          </PlanUI.Grid>
          <PlanUI.Purchase
            label={config.org_service.start_button.label}
            paymentUrl={config.org_service.start_button.link}
          >
            {config.org_service.uni_line_price}
          </PlanUI.Purchase>
        </PlanUI.Body>
      </PlanUI>
    </>
  );
}
